import { DomainModelRole } from '@/constants/cardTypes'

export const cardHelpers = {
  methods: {
    getCommandCard (event) {
      return event.cards?.filter((card) => card.cardType?.domainModelRole === DomainModelRole.COMMAND)
        .sort((a, b) => a.sortkey.localeCompare(b.sortkey))[0] || null
    },
    getQueryCards (event) {
      return event.cards?.filter((card) => card.cardType?.domainModelRole === DomainModelRole.READ_MODEL)
        .sort((a, b) => a.sortkey.localeCompare(b.sortkey)) || []
    },
    getEntityCard (event) {
      return event.cards?.find((card) => card.cardType?.domainModelRole === DomainModelRole.AGGREGATE_ROOT) || null
    },
    getDomainEventCard (event) {
      return event.cards?.find((card) => card.cardType?.domainModelRole === DomainModelRole.DOMAIN_EVENT) || null
    },
    getGwtCards (event) {
      return event.cards?.filter((card) => card.cardType?.domainModelRole === DomainModelRole.GIVEN_WHEN_THEN) || []
    },
    getCommandName (event) {
      const command = this.getCommandCard(event)
      return command?.description?.replace(/<\/?p>/g, '') // remove p tags
    },
    getEntityName (event) {
      const entity = this.getEntityCard(event)
      return entity?.description?.replace(/<\/?p>/g, '') // remove p tags
    }
  }
}
